function update_selector() {
  setTimeout(() => {
    document
      .querySelectorAll(".upsell_variant_selector")
      .forEach((selector) => selector.dispatchEvent(new Event("change")));
  }, 1500);
}

var upsellButton = null;
var upsellSelectedId = null;

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document
      .querySelectorAll(".subcollection-desktop-only")
      .forEach((el) => {
        el.style.display = "block";
      });
  }, 1500);

  document.addEventListener("click", (event) => {
    const swatchFilter = event.target.closest(".color_swatch_filter");
    if (!swatchFilter) return;
    const activeColor = swatchFilter.getAttribute("filter_value");
    const target = document.querySelector(
      `.tag--swatch .tag__checkbox-wrapper[filter_value="${activeColor}"]`
    );
    target?.click();
  });

  //------------------------- Bundle App Code -------------------------------
  const bundleInterval = setInterval(function () {
    const frequently_bought_item = document.querySelectorAll(
      ".cbb-recommendations-variant-select"
    );
    const checkboxes = document.querySelectorAll(
      ".cbb-frequently-bought-selector-input"
    );
    const addButton = document.querySelector(
      ".cbb-frequently-bought-add-button"
    );

    if (frequently_bought_item.length > 0) {
      frequently_bought_item.forEach(function (item) {
        const option = document.createElement("option");
        option.value = "select_option";
        option.textContent = "Grösse auswählen";
        item.insertBefore(option, item.firstChild);
        item.selectedIndex = 0;
        const itemShippingElement = document.createElement("div");
        itemShippingElement.classList.add("item_shipping_element");
        item.closest("li")?.appendChild(itemShippingElement);
        append_shipping(item);
      });

      if (addButton) {
        addButton.setAttribute("disabled", "true");
        addButton.style.opacity = "0.5";
      }

      clearInterval(bundleInterval);

      frequently_bought_item.forEach(function (item) {
        item.addEventListener("change", function () {
          const selectOption = item.querySelector(
            'option[value="select_option"]'
          );
          if (selectOption) {
            selectOption.remove();
          }

          if (addButton) {
            addButton.removeAttribute("disabled");
            addButton.style.opacity = "1";
          }

          append_shipping(item);

          checkboxes.forEach(function (checkbox) {
            if (checkbox.checked && addButton) {
              const selectElement = checkbox
                .closest("li")
                ?.querySelector(".cbb-recommendations-variant-select");
              if (selectElement && selectElement.value === "select_option") {
                addButton.setAttribute("disabled", "true");
                addButton.style.opacity = "0.5";
              }
            }
          });
        });
      });

      checkboxes.forEach(function (item) {
        item.addEventListener("change", function () {
          setTimeout(function () {
            const selected = [];
            frequently_bought_item.forEach(function (child) {
              const li_element = child.closest("li");
              const li_opacity = li_element
                ? window.getComputedStyle(li_element).opacity
                : "0";
              if (li_opacity === "1") {
                selected.push(child.value);
              }
            });
            if (addButton) {
              if (selected.includes("select_option")) {
                addButton.setAttribute("disabled", "true");
                addButton.style.opacity = "0.5";
              } else {
                addButton.removeAttribute("disabled");
                addButton.style.opacity = "1";
              }
            }
          }, 500);
        });
      });

      function append_shipping(item) {
        const active_link = item
          .closest("li")
          ?.querySelector(".cbb-frequently-bought-selector-link");
        if (active_link) {
          (async () => {
            const response = await fetch(active_link);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const deliveryTimeElement = doc.querySelector(
              ".product-block.product-block--delivery_time"
            );
            const itemShippingElement = item
              .closest("li")
              ?.querySelector(".item_shipping_element");
            if (deliveryTimeElement && itemShippingElement) {
              itemShippingElement.innerHTML = deliveryTimeElement.outerHTML;
            }
          })();
        } else {
          const shipping_element = document.querySelector(
            "[data-product-blocks] .product-block--delivery_time"
          )?.outerHTML;
          const itemShippingElement = item
            .closest("li")
            ?.querySelector(".item_shipping_element");
          if (shipping_element && itemShippingElement) {
            itemShippingElement.innerHTML = shipping_element;
          }
        }
      }
    }
  }, 200);

  setTimeout(function () {
    clearInterval(bundleInterval);
    console.log("The elements were not found within 1 minute.");
  }, 60000);

  // ----------- PDP Hide Empty Drop-Down ------------------
  const accordion_items = document.querySelectorAll("[data-tab-variant]");
  if (accordion_items.length > 0) {
    accordion_items.forEach((tab) => {
      const richTextField = tab.querySelector(".metafield-rich_text_field");
      const customTab = tab.closest(".custom_tab");
      const variantTabDisplay = window.getComputedStyle(tab).display;

      if (variantTabDisplay === "block") {
        if (richTextField && richTextField.innerHTML.trim() === "" && customTab) {
          customTab.style.display = "none";
        }
      }
    });
  }
  const data_tabs = document.querySelectorAll("[data-tab-layout-variant]");
  if (data_tabs.length > 0) {
    data_tabs.forEach((variantTab) => {
      const richTextField = variantTab.querySelector(
        ".metafield-rich_text_field"
      );
      const customTabId = variantTab
        .closest(".tab_content_main")
        ?.getAttribute("id");
      const tab_ = document
        .querySelector('.variant-tabs-nav a[href="#' + customTabId + '"]')
        ?.closest("li");
      const variantTabDisplay = window.getComputedStyle(variantTab).display;

      if (
        richTextField &&
        richTextField.innerHTML.trim() === "" &&
        variantTabDisplay === "block" &&
        tab_
      ) {
        tab_.style.display = "none";
      }
    });
  }

  // --------------------------------------- Cart Upsell ---------------------------------------
  function updateVariantID() {
    const selectors = document.querySelectorAll(".upsell_variant_selector");
    const selectedOptions = [];

    selectors.forEach((el) => {
      selectedOptions.push(el.value);
    });

    const variantsEl = document.querySelector(".upsell_variants_data");
    if (!variantsEl) return;

    const variantsJson = variantsEl.getAttribute("upsell_variants");

    let upsell_variants;
    try {
      upsell_variants = JSON.parse(variantsJson);
    } catch (e) {
      console.error("Invalid JSON in upsell_variants:", e);
      return;
    }

    const selectedVariant = upsell_variants.find((variant) =>
      variant.options.every((option, index) => option === selectedOptions[index])
    );

    if (selectedVariant) {
      const btn = document.querySelector(".upsell_add_to_cart");

      if (btn) {
        if (selectedVariant.available) {
          btn.textContent = "HINZUFÜGEN";
          btn.classList.remove("sold_out_btn");
        } else {
          btn.textContent = "AUSVERKAUFT";
          btn.classList.add("sold_out_btn");
        }

        btn.setAttribute("first_variant", selectedVariant.id);
      }

      const img = document.querySelector(".cart_upsell_item_image img");
      if (img && selectedVariant.featured_image) {
        img.src = selectedVariant.featured_image.src;
      }

      const price = document.querySelector(".upsell_Item__price");
      if (price) {
        price.innerText = (selectedVariant.price / 100)
          .toFixed(2)
          .replace(".", ",");
      }
    }

    // Disable invalid options
    selectors.forEach((currentSelect, index) => {
      selectors.forEach((otherSelect, otherIndex) => {
        if (index === otherIndex) return;

        let currentSelectionCopy = [...selectedOptions];

        if (!otherSelect.dataset.originalOptions) {
          otherSelect.dataset.originalOptions = otherSelect.innerHTML;
        }

        const options = otherSelect.querySelectorAll("option");

        options.forEach((opt) => {
          const optionValue = opt.value;
          currentSelectionCopy[otherIndex] = optionValue;

          const match = upsell_variants.find(
            (variant) =>
              variant.options.every(
                (o, i) => o === currentSelectionCopy[i]
              ) && variant.available
          );

          opt.disabled = !match;
        });

        const selected = otherSelect.querySelector("option:checked");

        if (selected && selected.disabled) {
          const firstValid = otherSelect.querySelector("option:not(:disabled)");
          if (firstValid) {
            otherSelect.value = firstValid.value;
            selectedOptions[otherIndex] = firstValid.value;
          }
        }
      });
    });
  }

  // Variant selector change
  document.addEventListener("change", function (e) {
    if (e.target.closest(".upsell_variant_selector")) {
      updateVariantID();
    }
  });

  // Add to cart click
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".upsell_add_to_cart");
    if (!btn) return;

    const first_id = btn.getAttribute("first_variant");

    const upsell_data = {
      id: first_id,
      quantity: 1,
    };

    btn.classList.add("btn--loading");
    btn.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(upsell_data),
    })
      .then((res) => res.json())
      .then(() => fetch("/cart.js"))
      .then((res) => res.json())
      .then((cart) => {
        cart.items.forEach((item) => {
          if (item.id == first_id) {
            const upsell = document.querySelector(".cart_upsell_main");
            if (upsell) upsell.style.display = "none";
          }
        });

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", { bubbles: true })
        );
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });

  document.addEventListener("cart:updated", () => {
    if (!upsellButton || !upsellSelectedId) return;
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const productAvailable = cart.items.some(
          (item) => String(item.id) === String(upsellSelectedId)
        );
        if (!productAvailable) {
          upsellButton.classList.remove("btn--loading");
          upsellButton.removeAttribute("disabled");
          const upsellMain = document.querySelector(".cart_upsell_main");
          if (upsellMain) {
            upsellMain.style.display = "block";
          }
        }
      })
      .catch((error) => console.error("Error fetching cart:", error));
  });

// --------------------------------------- End Cart Upsell ---------------------------------------

  setTimeout(function () {
    const loadSwiperAssets =
      window.ensureSwiperAssets ||
      function () {
        if (window._swiperPromise) return window._swiperPromise;

        const SWIPER_CSS_URL = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
        const SWIPER_JS_URL = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";

        window._swiperPromise = new Promise((resolve, reject) => {
          const head = document.head || document.getElementsByTagName("head")[0];

          if (!document.querySelector('link[data-swiper="true"]')) {
            const link = document.createElement("link");
            link.setAttribute("data-swiper", "true");
            link.rel = "preload";
            link.as = "style";
            link.href = SWIPER_CSS_URL;
            link.onload = () => {
              link.rel = "stylesheet";
            };
            link.onerror = reject;
            head.appendChild(link);

            if (!document.querySelector("noscript[data-swiper-noscript]")) {
              const noscript = document.createElement("noscript");
              noscript.setAttribute("data-swiper-noscript", "true");
              noscript.innerHTML = `<link rel="stylesheet" href="${SWIPER_CSS_URL}">`;
              head.appendChild(noscript);
            }
          }

          if (window.Swiper) {
            resolve(window.Swiper);
            return;
          }

          const script = document.createElement("script");
          script.src = SWIPER_JS_URL;
          script.defer = true;
          script.onload = () => resolve(window.Swiper);
          script.onerror = reject;
          head.appendChild(script);
        });

        return window._swiperPromise;
      };

    const sliders = document.querySelectorAll(".product_item_image_slider");
    if (!sliders.length) return;

    loadSwiperAssets()
      .then(() => {
        sliders.forEach((element) => {
          const parentContainer = element.closest(".pdp_slider_parent");
          if (!parentContainer) return;
          const swiper = new Swiper(element, {
            scrollbar: {
              el: parentContainer.querySelector(".swiper-scrollbar"),
              hide: false,
            },
            on: {
              slideChange: function () {
                updateNavigationButtons();
              },
            },
          });

          const card_prevButton = parentContainer.querySelector(".card_btn_prev");
          const card_nextButton = parentContainer.querySelector(".card_btn_next");
          card_prevButton?.addEventListener("click", () => swiper.slidePrev());
          card_nextButton?.addEventListener("click", () => swiper.slideNext());

          function updateNavigationButtons() {
            if (card_prevButton) {
              card_prevButton.style.visibility = swiper.isBeginning
                ? "hidden"
                : "visible";
            }
            if (card_nextButton) {
              card_nextButton.style.visibility = swiper.isEnd
                ? "hidden"
                : "visible";
            }
          }
          updateNavigationButtons();
        });
      })
      .catch((error) => console.error("Failed to load Swiper assets", error));
  }, 300);

  // ----------------------- Buy Box Price Mutation ----------------------
  const targetElement = document.querySelector(
    ".product-section-var-a .product-block--price"
  );
  if (targetElement) {
    const observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        if (
          mutation.type === "childList" ||
          mutation.type === "subtree" ||
          mutation.type === "characterData"
        ) {
          const targetCopyElement = document.querySelector(
            ".product-section-var-b .product-block--price"
          );
          if (targetCopyElement) {
            targetCopyElement.innerHTML = targetElement.innerHTML;
          }
        }
      });
    });
    observer.observe(targetElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  //---------------------- Buy Box random Visitors -------------------
  const visitCountElement = document.querySelector(".random_visit_count");
  const randomVisitorsCount = document.querySelector(".random_visitors_count");
  let visitCountElement_id =
    visitCountElement
      ?.closest(".random_visit_text")
      ?.getAttribute("product_id") || "";
  if (visitCountElement_id === "") {
    visitCountElement_id =
      randomVisitorsCount
        ?.closest(".random_visitors_main")
        ?.getAttribute("product_id") || "";
  }

  if (visitCountElement || randomVisitorsCount) {
    const storageKey = "randomVisitCount" + visitCountElement_id;
    const timeKey = "randomVisitCountTime" + visitCountElement_id;
    const oneHour = 60 * 60 * 1000;

    const now = Date.now();
    const savedCount = localStorage.getItem(storageKey);
    const savedTime = localStorage.getItem(timeKey);

    if (savedCount && savedTime && now - Number(savedTime) < oneHour) {
      if (visitCountElement) {
        visitCountElement.textContent = `${savedCount} Personen`;
        const wrapper = visitCountElement.closest(".random_visit_text");
        wrapper?.classList.remove("hide_random");
      }
      if (randomVisitorsCount) {
        randomVisitorsCount.textContent = savedCount;
        const wrapper = randomVisitorsCount.closest(".random_visitors_main");
        wrapper?.classList.remove("hide_random");
      }
    } else {
      const randomCount = Math.floor(Math.random() * (400 - 20 + 1)) + 20;
      if (visitCountElement) {
        visitCountElement.textContent = `${randomCount} Personen`;
        const wrapper = visitCountElement.closest(".random_visit_text");
        wrapper?.classList.remove("hide_random");
      }
      if (randomVisitorsCount) {
        randomVisitorsCount.textContent = randomCount;
        const wrapper = randomVisitorsCount.closest(".random_visitors_main");
        wrapper?.classList.remove("hide_random");
      }
      localStorage.setItem(storageKey, String(randomCount));
      localStorage.setItem(timeKey, now.toString());
    }
  }

  //----------------------- Update Discount Value ----------------------
  function parsePrice(priceString) {
    let cleaned = priceString.replace(/[^\d.,-]/g, "");
    if (cleaned.includes(".") && cleaned.includes(",")) {
      cleaned = cleaned.replace(/\./g, "").replace(",", ".");
    } else if (cleaned.includes(",")) {
      cleaned = cleaned.replace(",", ".");
    }
    return parseFloat(cleaned);
  }

  document.addEventListener("change", (event) => {
    const couponInput = event.target.closest(".elsklip-coupon__text input");
    if (!couponInput) return;
    const parentElement = couponInput.closest(".product-single__meta");
    if (!parentElement) return;

    setTimeout(function () {
      const comparePriceElement = parentElement.querySelector(
        ".product__price.product__price--compare"
      );
      const discountedPriceElement = parentElement.querySelector(
        ".elsklip-discounted-price"
      );
      const dataPriceElement = parentElement.querySelector(
        "[data-product-price]"
      );
      const savingText = parentElement.querySelector(".saving_value_text_pdp");
      if (!comparePriceElement || !dataPriceElement || !savingText) return;

      const compare_Price = parsePrice(comparePriceElement.textContent || "0");
      if (couponInput.checked) {
        const regular_Price = parsePrice(
          discountedPriceElement?.textContent || "0"
        );
        const differance = parseFloat(compare_Price - regular_Price)
          .toFixed(2)
          .replace(".", ",");

        dataPriceElement.textContent = regular_Price.toLocaleString("de-DE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + " €";
        savingText.textContent = "-" + differance + " €";
      } else {
        const storedPrice =
          dataPriceElement.getAttribute("data-price") ||
          dataPriceElement.dataset.price ||
          "";
        const regular_Price = parsePrice(storedPrice || "0");
        dataPriceElement.textContent = storedPrice;
        const differance = parseFloat(compare_Price - regular_Price)
          .toFixed(2)
          .replace(".", ",");
        savingText.textContent = "-" + differance + " €";
      }
    }, 1600);
  });

  const checkElsKlip = setInterval(() => {
    const elsklipCheck = document.querySelector(".elsklip-coupon__text");
    if (elsklipCheck) {
      setTimeout(function () {
        const parentElement = elsklipCheck.closest(".product-single__meta");
        const input = elsklipCheck.querySelector("input");
        if (!parentElement || !input || !input.checked) return;
        const comparePriceElement = parentElement.querySelector(
          ".product__price.product__price--compare"
        );
        const discountedPriceElement = parentElement.querySelector(
          ".elsklip-discounted-price"
        );
        const dataPriceElement = parentElement.querySelector(
          "[data-product-price]"
        );
        const savingText = parentElement.querySelector(".saving_value_text_pdp");
        if (
          comparePriceElement &&
          discountedPriceElement &&
          dataPriceElement &&
          savingText
        ) {
          const compare_Price = parsePrice(comparePriceElement.textContent);
          const regular_Price = parsePrice(discountedPriceElement.textContent);
          dataPriceElement.textContent = regular_Price.toLocaleString("de-DE", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) + " €";
          const differance = parseFloat(compare_Price - regular_Price)
            .toFixed(2)
            .replace(".", ",");
          savingText.textContent = "-" + differance + " €";
        }
      }, 1600);
      clearInterval(checkElsKlip);
    }
  }, 500);

  document.addEventListener("click", (event) => {
    const showAllColor = event.target.closest(".show_all_color");
    if (!showAllColor) return;
    const list = showAllColor.closest(".cp_swatches_list");
    if (list) {
      list.classList.remove("show_less_color");
    }
    showAllColor.style.display = "none";
  });
});

//----------------------- Cart Drawer Timer -----------------------
const STORAGE_KEY = "cartCountdownTimer";
const EXPIRATION_KEY = "cartCountdownExpiration";
const DEVICE_TYPE_KEY = "cartCountdownDevice";
const EXPIRATION_DAYS = 1;

// Determine current device type
const currentDevice = window.innerWidth < 767 ? "mobile" : "desktop";
window.countdown_duration = currentDevice === "mobile" ? 60 * 10 : 60 * 15;

let globalTimer = null;
let globalInterval = null;

function getStoredTimer() {
  const storedTimer = localStorage.getItem(STORAGE_KEY);
  const expiration = localStorage.getItem(EXPIRATION_KEY);
  const storedDevice = localStorage.getItem(DEVICE_TYPE_KEY);

  if (storedDevice && storedDevice !== currentDevice) {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(EXPIRATION_KEY);
    localStorage.removeItem(DEVICE_TYPE_KEY);
    return null;
  }

  if (storedTimer && expiration) {
    if (new Date().getTime() > parseInt(expiration)) {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(EXPIRATION_KEY);
      localStorage.removeItem(DEVICE_TYPE_KEY);
      return null;
    }
    return parseInt(storedTimer);
  }
  return null;
}

function setStoredTimer(timer) {
  localStorage.setItem(STORAGE_KEY, timer.toString());
  const expiration =
    new Date().getTime() + EXPIRATION_DAYS * 24 * 60 * 60 * 1000;
  localStorage.setItem(EXPIRATION_KEY, expiration.toString());
  localStorage.setItem(DEVICE_TYPE_KEY, currentDevice);
}

function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
    .toString()
    .padStart(2, "0")}`;
}

function updateTimerDisplay() {
  const display = document.querySelector("#cartCountdown");
  const alertElement = document.querySelector(".cartCountdownAlert");

  if (display && alertElement) {
    if (globalTimer <= 0) {
      clearInterval(globalInterval);
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(EXPIRATION_KEY);
      localStorage.removeItem(DEVICE_TYPE_KEY);
      alertElement.style.display = "none";
    } else {
      display.textContent = formatTime(globalTimer);
      setStoredTimer(globalTimer);
      alertElement.style.display = "block";
    }
  }
}

function startBackgroundTimer() {
  if (globalInterval) {
    clearInterval(globalInterval);
  }

  globalInterval = setInterval(() => {
    const storedTimer = getStoredTimer();
    if (storedTimer !== null) {
      globalTimer = storedTimer;
    }

    if (globalTimer > 0) {
      globalTimer--;
      setStoredTimer(globalTimer);
      updateTimerDisplay();
    } else {
      clearInterval(globalInterval);
    }
  }, 1000);
}

function initializeCartCountdown() {
  update_selector();
  const storedTimer = getStoredTimer();

  if (storedTimer === null) {
    globalTimer = window.countdown_duration;
    setStoredTimer(globalTimer);
  } else {
    globalTimer = storedTimer;
  }
  const countdownMain = document.querySelector(".cartCountdown_main");
  if (countdownMain) {
    countdownMain.style.display = "block";
  }
  updateTimerDisplay();
  startBackgroundTimer();
}

function setCountdownDuration(seconds) {
  window.countdown_duration = seconds;
  const storedTimer = getStoredTimer();
  if (storedTimer !== null) {
    globalTimer = storedTimer;
  } else {
    resetTimer();
  }
}

function resetTimer() {
  globalTimer = window.countdown_duration;
  setStoredTimer(globalTimer);
  updateTimerDisplay();
  startBackgroundTimer();
}

window.setCountdownDuration = setCountdownDuration;
window.resetTimer = resetTimer;

document.addEventListener("ajaxProduct:added", initializeCartCountdown);

function checkInitially() {
  const storedTimer = getStoredTimer();

  if (storedTimer != null) {
    globalTimer = storedTimer;
  } else {
    setTimeout(function () {
      const countdownMain = document.querySelector(".cartCountdown_main");
      if (countdownMain) {
        countdownMain.style.display = "none";
      }
    }, 1000);
  }

  updateTimerDisplay();
  startBackgroundTimer();
}
checkInitially();
